import { render, staticRenderFns } from "./ViewLoan.vue?vue&type=template&id=3a98b9e9&scoped=true"
import script from "./ViewLoan.vue?vue&type=script&lang=js"
export * from "./ViewLoan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a98b9e9",
  null
  
)

export default component.exports